import { render, staticRenderFns } from "./searchQueries.vue?vue&type=template&id=35fb8638&scoped=true&"
import script from "./searchQueries.vue?vue&type=script&lang=js&"
export * from "./searchQueries.vue?vue&type=script&lang=js&"
import style0 from "./searchQueries.vue?vue&type=style&index=0&id=35fb8638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb8638",
  null
  
)

export default component.exports